/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createStoreGroup } from '../fn/store-groups/create-store-group';
import { CreateStoreGroup$Params } from '../fn/store-groups/create-store-group';
import { deleteStoreGroup } from '../fn/store-groups/delete-store-group';
import { DeleteStoreGroup$Params } from '../fn/store-groups/delete-store-group';
import { Empty } from '../models/empty';
import { getAllStoreGroups } from '../fn/store-groups/get-all-store-groups';
import { GetAllStoreGroups$Params } from '../fn/store-groups/get-all-store-groups';
import { getStoreGroupById } from '../fn/store-groups/get-store-group-by-id';
import { GetStoreGroupById$Params } from '../fn/store-groups/get-store-group-by-id';
import { StoreGroup } from '../models/store-group';
import { StoreGroupDetailsResponse } from '../models/store-group-details-response';
import { StoreGroupsUpdateOutput } from '../models/store-groups-update-output';
import { updateStoreGroup } from '../fn/store-groups/update-store-group';
import { UpdateStoreGroup$Params } from '../fn/store-groups/update-store-group';

@Injectable({ providedIn: 'root' })
export class StoreGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllStoreGroups()` */
  static readonly GetAllStoreGroupsPath = '/store-groups';

  /**
   * Gets all store groups details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStoreGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStoreGroups$Response(params: GetAllStoreGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StoreGroupDetailsResponse>>> {
    return getAllStoreGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all store groups details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllStoreGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStoreGroups(params: GetAllStoreGroups$Params, context?: HttpContext): Observable<Array<StoreGroupDetailsResponse>> {
    return this.getAllStoreGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<StoreGroupDetailsResponse>>): Array<StoreGroupDetailsResponse> => r.body)
    );
  }

  /** Path part for operation `createStoreGroup()` */
  static readonly CreateStoreGroupPath = '/store-groups';

  /**
   * Create a store group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStoreGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStoreGroup$Response(params: CreateStoreGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreGroup>> {
    return createStoreGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a store group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStoreGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStoreGroup(params: CreateStoreGroup$Params, context?: HttpContext): Observable<StoreGroup> {
    return this.createStoreGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreGroup>): StoreGroup => r.body)
    );
  }

  /** Path part for operation `getStoreGroupById()` */
  static readonly GetStoreGroupByIdPath = '/store-groups/{storeGroupId}';

  /**
   * Gets details for a specified store group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStoreGroupById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreGroupById$Response(params: GetStoreGroupById$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreGroupDetailsResponse>> {
    return getStoreGroupById(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets details for a specified store group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStoreGroupById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoreGroupById(params: GetStoreGroupById$Params, context?: HttpContext): Observable<StoreGroupDetailsResponse> {
    return this.getStoreGroupById$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreGroupDetailsResponse>): StoreGroupDetailsResponse => r.body)
    );
  }

  /** Path part for operation `updateStoreGroup()` */
  static readonly UpdateStoreGroupPath = '/store-groups/{storeGroupId}';

  /**
   * Update store group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStoreGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStoreGroup$Response(params: UpdateStoreGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreGroupsUpdateOutput>> {
    return updateStoreGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Update store group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStoreGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStoreGroup(params: UpdateStoreGroup$Params, context?: HttpContext): Observable<StoreGroupsUpdateOutput> {
    return this.updateStoreGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreGroupsUpdateOutput>): StoreGroupsUpdateOutput => r.body)
    );
  }

  /** Path part for operation `deleteStoreGroup()` */
  static readonly DeleteStoreGroupPath = '/store-groups/{storeGroupId}';

  /**
   * Delete store group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStoreGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStoreGroup$Response(params: DeleteStoreGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return deleteStoreGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete store group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStoreGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStoreGroup(params: DeleteStoreGroup$Params, context?: HttpContext): Observable<Empty> {
    return this.deleteStoreGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

}
